import React, { useState } from "react";
import ScheduleEventForm from "../../components/schedule/ScheduleEventForm";
import { SeasonEvents } from "../../components/schedule/SeasonSchedule";
import { useSeasonsStore } from "../../store/seasonsStore";

const Schedule: React.FC<any> = () => {
  const { currentSeason } = useSeasonsStore();
  const [isCreatingEvent] = useState(false);
  return (
    <div className="pt-2 bg-gray-100 dark:bg-gray-800 ">
      <>
        {!isCreatingEvent && (
          <>
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                  Season Schedule
                </h1>
                <p className="mt-2 text-sm text-gray-700 dark:text-gray-200">
                  View current season schedule.
                </p>
              </div>
            </div>
            <SeasonEvents events={currentSeason?.seasonEvents} />
          </>
        )}
        {isCreatingEvent && <ScheduleEventForm />}
      </>
    </div>
  );
};

export default Schedule;
